import React from "react";
import { Link } from "react-router-dom";
import cards from "../assets/cards.png";
import card2 from "../assets/card2.png";

const Footer = () => {
  return (
    <footer className="bg-[#191919] lg:bg-[#191919] text-white py-8 font-inter">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 mb-16 space-y-8">

        {/* Navigation Links - Updated with Legal Links */}
        <div className="flex flex-wrap justify-center gap-4 lg:gap-8 text-sm">
          <Link to="/term-conditions" className="hover:text-primary whitespace-nowrap">
            Terms & Conditions
          </Link>
          <Link to="/copyright" className="hover:text-primary whitespace-nowrap">
            Copyright
          </Link>
          <Link to="/aml-policy" className="hover:text-primary whitespace-nowrap">
            AML Policy
          </Link>
          <Link to="/refund-policy" className="hover:text-primary whitespace-nowrap">
            Refund Policy
          </Link>
          <Link to="/contact-us" className="hover:text-primary whitespace-nowrap">
            Contact
          </Link>
        </div>

        {/* Social Media Icons */}
        <div className="flex justify-center gap-8 text-lg">
          <a
            href="https://x.com/futcoinspot?s=21"
            className="hover:text-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-twitter">X</i>
          </a>
          <a
            href="https://discord.gg/Kvmu2sPSpd"
            className="hover:text-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-discord">Discord</i>
          </a>
        </div>

        {/* Payment Gateway Section */}
        <div className="text-center">
          <p className="text-sm lg:text-base">
            We offer secure payment processing through{" "}
            <span className="font-bold">Stripe</span>.
          </p>
          <div className="flex justify-center items-center">
            <img src={cards} alt="Payment Cards" width={120} height={40} />
            <img src={card2} alt="Additional Payment Cards" width={120} height={40} />
          </div>
        </div>


        {/* Copyright Section */}
        <div className="text-center text-xs lg:text-sm">
          © Copyright 2025 - Futcoinspot
        </div>
      </div>
    </footer>
  );
};

export default Footer;
